import { render, staticRenderFns } from "./categoryModel.vue?vue&type=template&id=067cd60d"
import script from "./categoryModel.vue?vue&type=script&lang=js"
export * from "./categoryModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('067cd60d')) {
      api.createRecord('067cd60d', component.options)
    } else {
      api.reload('067cd60d', component.options)
    }
    module.hot.accept("./categoryModel.vue?vue&type=template&id=067cd60d", function () {
      api.rerender('067cd60d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/categoryLabelManage/categoryModel.vue"
export default component.exports